import exifr from 'exifr';

/**
 * Best-effort EXIF / QuickTime metadata from a video File (MP4/MOV).
 * @param {File} file
 * @returns {Promise<{
 *   createdAt: string | null,
 *   lat: number | null,
 *   lng: number | null,
 *   altitude: number | null,
 *   cameraModel: string | null,
 *   focalLength: string | null,
 * } | null>}
 */
export async function extractVideoMetadata(file) {
  if (!file || typeof file !== 'object') return null;
  try {
    const data = await exifr.parse(file, {
      gps: true,
      tiff: true,
      exif: true,
      ifd0: true,
      xmp: true,
    });
    if (!data || typeof data !== 'object') return null;

    let createdAt = data.CreateDate || data.DateTimeOriginal || data.ModifyDate || data.MediaCreateDate;
    if (createdAt instanceof Date) {
      createdAt = createdAt.toISOString();
    } else if (createdAt != null) {
      createdAt = String(createdAt);
    } else {
      createdAt = null;
    }

    let lat = data.latitude ?? data.GPSLatitude;
    let lng = data.longitude ?? data.GPSLongitude;
    if (typeof lat !== 'number' || !Number.isFinite(lat)) lat = null;
    if (typeof lng !== 'number' || !Number.isFinite(lng)) lng = null;

    let altitude = data.GPSAltitude ?? data.altitude;
    if (altitude && typeof altitude === 'object' && altitude.value != null) {
      altitude = altitude.value;
    }
    if (typeof altitude !== 'number' || !Number.isFinite(altitude)) altitude = null;

    let focalLength = data.FocalLength;
    if (focalLength && typeof focalLength === 'object' && focalLength.value != null) {
      focalLength = focalLength.value;
    }
    const focalStr =
      focalLength != null && Number.isFinite(Number(focalLength))
        ? `${Math.round(Number(focalLength) * 10) / 10}mm`
        : focalLength != null
          ? String(focalLength)
          : null;

    const cameraModel =
      (data.Model && String(data.Model).trim()) ||
      (data.Make && String(data.Make).trim()) ||
      null;

    return {
      createdAt,
      lat,
      lng,
      altitude,
      cameraModel,
      focalLength: focalStr,
    };
  } catch {
    return null;
  }
}
